"use client";
import m from "humps";
import "react";
import { create as p } from "./create.js";
const e = /* @__PURE__ */ new Map();
function u(n = {}, c = "core", s = ({ children: o }) => o) {
  return new Proxy(n, {
    get: function(f, a) {
      const r = m.decamelize(a, { separator: "-" }), t = `${c}-${r}`;
      if (!e.has(t)) {
        const i = p({ tag: r, render: s });
        e.set(t, i);
      }
      return e.get(t);
    }
  });
}
const y = u();
export {
  u as createProxy,
  y as default
};
